(ns teamoesterreich.admin-mode.content.news-admin
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.news :as d-news]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]


            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.image-drop-upload :as image-drop-upload]
            [teamoesterreich.admin-mode.ui-helper.block-edit-card :as block-edit-card]


            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.save :refer [save]]
            ))


(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))



(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(defn get-it []
  (let [!form-data (r/atom {})]
    (fn []
      (let [!news-list (r/cursor vstate/app-state [:news-list])
            !loaded (r/cursor !news-list [:loaded])
            !opened  (r/cursor !news-list [:opened])
            !data (r/cursor !news-list [:data @!opened])
            !publish-popup (r/cursor !news-list [:show-publish-popup])
            !delete-popup (r/cursor !news-list [:show-delete-popup])
            reload-fn #(reset! !loaded false)


            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key)))
                       (and (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key))))
            has-changes? (or
                           (changed? :news-title)
                           (changed? :news-date)
                           (changed? :news-toDate)
                           )
            change-fn (fn [key value]
                        (log/debug "change " key value)
                        (swap! !form-data assoc key value))
            ]
        (when-not @!loaded
          (do
            (d-news/get-news-list
              (fn [response]
                (swap! !news-list assoc :loaded true :data response)))
            [mui/paper
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Daten ... "]
             ]
            ))
        (log/debug "News edit" @!data @!loaded @!form-data)
        (when-not @!data (a/set-page :news-list))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style {:textAlign "left" :marginBottom "50px"}
          }
         [mui/grid
          {:item  true
           :xs    12
           :style {:height "50px"}
           }
          [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                           :onClick reload-fn}
           "News"]]

         [are-you-sure-modal/are-you-sure-modal !publish-popup
          "Bist du sicher, dass du diese News veröffentlichen möchtest? Alle Mitglieder werden die News sehen können!" "Ja veröffentlichen"
          (fn [_] (d-news/>news-edit @!opened {:news-published true}  reload-fn)) ]
         [are-you-sure-modal/are-you-sure-modal !delete-popup
          "Bist du sicher, dass du diese News löschen möchtest? " "Ja löschen"
          (fn [_]
            (d-news/>news-edit @!opened {:news-active false} reload-fn)
            (a/set-page :news-list)
            ) ]


         [mui/grid
          {:container false
           :item true
           :xl 7
           :xs 12  ;extra-small: 0px
           }

          [mui/card
           [mui/card-header
            {:title (str (:news-title @!data))}]


           [mui/card-content


            [mui/card
             [mui/card-content
              [mui/grid
               {:container  true
                :direction  "row"
                :alignItems "stretch"
                :justify    "flex-start"
                :style {:textAlign "left"}
                }
              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [(image-drop-upload/get-it (:news-imageUri @!data)
                                          (fn [new-url]
                                            (d-news/>news-edit-img (:news-uuid @!data) new-url reload-fn))
                                          {:width 400 :max-height 400})]
               [:br]
               [:span "Ideale Größe ist 420x200 px "]
               ]

              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :news-title) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                ;:disabled     (not @!edit-mode)
                                :defaultValue (str (:news-title @!data))
                                :onChange     (fn [e] (change-fn :news-title (h/event-value e)))
                                :label        "News Titel"}]
               ]

              [mui/grid
               {:container false :item true
                :md        3                                   ;medium: 960px
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }

               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :news-date) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :type         "datetime-local"
                                :autoOk       true
                                :label        "News Von-Datum"
                                :onChange     (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :news-date date)))
                                :defaultValue (datetime-conv (:news-date @!data))
                                }]
               ]
              [mui/grid
               {:container false :item true
                :md        3                                   ;medium: 960px
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }

               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :news-toDate) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :type         "datetime-local"
                                :autoOk       true
                                :label        "News Bis-Datum"
                                :onChange     (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :news-toDate date)))
                                :defaultValue (datetime-conv (:news-toDate @!data))
                                }]
               ]
              ]
             [mui/card-actions
              [mui/button {
                           :variant   "contained"
                           :startIcon (r/as-element [keyboard-arrow-left])
                           :disabled (not has-changes?)

                           } "Abbrechen"]

              [mui/button {
                           :variant   "contained"
                           :color "primary"
                           :startIcon (r/as-element [save])
                           :disabled (not has-changes?)
                           :onClick (fn [] (d-news/>news-edit (:news-uuid @!data) @!form-data reload-fn))
                           } "Speichern"]
              ]
             ]]]





           [mui/card-content {:style {:textAlign "left" }}
            [(block-edit-card/get-it (:news-content @!data)
                                     (fn [c] (d-news/>news-edit (:news-uuid @!data) {:news-content c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                     {:title "Kurzer Text"})]
            ]


           [mui/card-content {:style {:textAlign "left" }}
            [(edit-md-card/get-it (:news-longContent @!data)
                                  (fn [c] (d-news/>news-edit (:news-uuid @!data) {:news-longContent c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                  (str backend/BASE_URL "/media-upload")
                                  "Inhalt")]
            ]


           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (reset! !opened nil)
                                      (a/set-page :news-list))
                         }
             "Schließen"
             ]
            [mui/form-group
             [mui/form-control-label
              {:style {:paddingLeft "126px"}
               :label "News veröffentlichen"
               :fullWidth true
               :control (r/as-element
                          [mui/switch
                           {
                            :checked (or (get @!data :news-published) false)
                            :onChange (fn [_ v]
                                        (if v (reset! !publish-popup true)
                                              (d-news/>news-edit @!opened {:news-published false}  reload-fn)))
                            }])}
              ]]

            [mui/button {:startIcon (r/as-element [delete-forever])
                         :onClick #(reset! !delete-popup true)
                         :color "secondary"
                         :style {:marginLeft "150px"}
                         }
             "Löschen"
             ]

            ]]]

         ]))
    ))